import { InfoStage } from '../../../types/forms/fields'
import { selectCoverageOption } from './utils'

export const notPregnantNote: InfoStage = {
  info: true,
  name: 'Notice',
  condition: selectCoverageOption('not-pregnant'),
  data: [
    {
      type: 'span',
      children: [
        {
          text: `Hamilton Billing is happy to provide you with an assessment, however, please be aware that we only provide one free assessment per pregnancy. We recommend patients circle back with us when they are pregnant. 

In the meantime, click "Finish" to see some general information on insurance plans we often work with. 
          
If you would like to complete an assessment now, please choose the coverage option that currently applies from the drop down above and indicate in one of the notes boxes that you are not pregnant.`,
        },
      ],
    },
  ],
}
